<a
  class="secondary-link no-decoration"
  *ngIf="segment"
  [routerLink]="segment.link"
  [style.color]="color"
>
  {{ label }}
</a>
